/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S1_Label_Vergi_DairesiInputs */

const tr_onbilgi_s1_label_vergi_dairesi = /** @type {(inputs: Onbilgi_S1_Label_Vergi_DairesiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergi Dairesi:`)
};

const en_onbilgi_s1_label_vergi_dairesi = /** @type {(inputs: Onbilgi_S1_Label_Vergi_DairesiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax Office (Vergi Dairesi):`)
};

const de_onbilgi_s1_label_vergi_dairesi = /** @type {(inputs: Onbilgi_S1_Label_Vergi_DairesiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finanzamt (Vergi Dairesi):`)
};

const ru_onbilgi_s1_label_vergi_dairesi = /** @type {(inputs: Onbilgi_S1_Label_Vergi_DairesiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Налоговая инспекция (Vergi Dairesi):`)
};

/**
* | output |
* | --- |
* | "Tax Office (Vergi Dairesi):" |
*
* @param {Onbilgi_S1_Label_Vergi_DairesiInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s1_label_vergi_dairesi = /** @type {((inputs?: Onbilgi_S1_Label_Vergi_DairesiInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S1_Label_Vergi_DairesiInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s1_label_vergi_dairesi(inputs)
	if (locale === "de") return de_onbilgi_s1_label_vergi_dairesi(inputs)
	if (locale === "ru") return ru_onbilgi_s1_label_vergi_dairesi(inputs)
	return tr_onbilgi_s1_label_vergi_dairesi(inputs)
});